module.exports = __webpack_public_path__ + "static/media/Volex_bild_undersida2.42a12935.jpg";